import axios from "axios";
import { environment } from "../../environments/environment";
import { ISetPassword } from "../../models/ISetPassword";
import { Auth_URL } from "../../constants/backendUrl";
export class SetPasswordService {
  private static URL: any = environment.authApiUrl;

  public static setUserPassword(data: ISetPassword) {
    let UserURL: string = `${this.URL}/${Auth_URL.setPassword}`;
    return axios.post<any>(UserURL, data);
  }

  public static getUserByToken(token: string | undefined) {
    let UserURL: string = `${this.URL}/${Auth_URL.setPasswordToken}?token=${token}`;
    return axios.get<any>(UserURL);
  }

  public static forgotPassword(userName: string) {
    let UserURL: string = `${this.URL}/${Auth_URL.forgotPassword}?userName=${encodeURIComponent(userName)}`;
    return axios.post<any>(UserURL, userName);
  }

  public static getUserByForgotPasswordToken(token: string | undefined) {
    let UserURL: string = `${this.URL}/${Auth_URL.forgotPasswordToken}?token=${token}`;
    return axios.get<any>(UserURL);
  }

  public static resetUserPassword(data: ISetPassword) {
    let UserURL: string = `${this.URL}/${Auth_URL.resetPassword}`;
    return axios.post<any>(UserURL, data);
  }
}
